import styles from './ModalForm.module.css';

const ModalFormBody = ({children}) => {
    return <div className={styles.modalFormBody}>
        {children}
    </div>;
};

export default ModalFormBody;